import classNames from "classnames";
import styles from "./switch.module.css";

const Switch = ({ disabled = false, checked, onChange, ...rest }) => {
  const handleClick = (e) => {
    onChange?.();
  };

  return (
    <div
      className={classNames(styles.switchTrack, { [styles.checked]: checked })}
      onClick={handleClick}
    >
      <div className={styles.switchThumb}></div>
    </div>
  );
};

export default Switch;
